export class State {
    message = {};
}
